export class State {
    message = {};
}
